import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { getParametroExercicio } from "../../../../service/Rag/Exercicio";
import ModalRagCronograma from "./modalRagCronograma";
import Prorrogacao from "./prorrogracao";
const Cronograma = ({ setCronogramaVisible, setExercicioVisible, exercicio }) => {
  const [prorrogacao, setProrrogacao] = useState(false);
  const [data, setData] = useState({ ...exercicio });
  const [visibleModal, setVisibleModal] = useState(false);
  const [cronograma, setCronograma] = useState([]);
  const [edit, setEdit] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [atualizaList, setAtualizaList] = useState(true);

  function handleShowModalRagCronograma() {
    setVisibleModal(true);
    setCronograma({ fase: null, dataInicial: "", dataFinal: "", descCronograma: "", tipoItemRag: "" });
    setEdit(false);
  }

  const showProrrogracao = (_cronograma) => {
    setCronograma(_cronograma);
    setProrrogacao(true);
  };

  const actionPrrogacoes = (node) => {
    let buttonProrogracao;

    if (["A", "P", "I"].includes(node.tipoItemRag) && node.fase.idenFase === 3) {
      buttonProrogracao = (
        <Button
          type="button"
          icon="pi pi-clock"
          className="p-button-sm p-button-success"
          style={{ marginRight: ".5em" }}
          tooltip="Prorrogações"
          onClick={() => {
            showProrrogracao(node);
          }}
        ></Button>
      );
    }
    return <div>{buttonProrogracao}</div>;
  };
  const actionTemplate = (node, rowData) => {
    return buttonTable(node, rowData);
  };

  const buttonTable = (node, rowData) => {
    let editarButton, vizualizarButton;

    editarButton = (
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-warning"
        style={{ marginRight: ".5em" }}
        onClick={() => editExercicio(node)}
      ></Button>
    );

    if (rowData.flagAtivoMonitora !== "S") {
      vizualizarButton = (
        <Button
          type="button"
          icon="pi pi-eye p-button-icon"
          className="p-button-help p-button p-component p-button-icon-only"
          onClick={() => showExercicio(node)}
        ></Button>
      );
    }

    return (
      <>
        {editarButton} {vizualizarButton}
      </>
    );
  };

  const editExercicio = (_cronograma) => {
    setCronograma({ ..._cronograma });
    setEdit(true);
    setVisibleModal(true);
  };

  const showExercicio = (_cronograma) => {
    setCronograma({ ..._cronograma });
    setEdit(true);
    setDisabled(true);
    setVisibleModal(true);
  };

  const showCronograma = (_cronograma, event) => {
    event.preventDefault();
    setCronograma(_cronograma);
    setExercicioVisible(false);
    setCronogramaVisible(true);
  };

  const closeCronograma = (_cronograma) => {
    setCronogramaVisible(false);
    setExercicioVisible(true);
  };
  const header = (
    <div className="table-header">
      Cronograma
      <Button
        type="button"
        onClick={() => {
          handleShowModalRagCronograma();
        }}
      >
        <span className="p-button-label">Cadastrar Cronograma</span>
      </Button>
    </div>
  );
  const footer = (
    <div className="table-footer">
      <p> </p>

      <Button type="button" onClick={closeCronograma}>
        <span className="pi pi-arrow-left p-button-icon p-button-icon-left"></span>
        <span className="p-button-label">Voltar </span>
      </Button>
    </div>
  );
  useEffect(() => {
    if (atualizaList === true) {
      getParametroExercicio(exercicio.idenParametroExercicio).then((res) => {
        setData({
          cronograma: res.data.cronograma,
        });
      });
      setAtualizaList(false);
    }
  }, [atualizaList, exercicio.idenParametroExercicio]);
  return (
    <>
      {!prorrogacao && (
        <div className="datatable">
          <div className="card">
            <DataTable
              header={header}
              footer={footer}
              value={data.cronograma}
              stripedRows
              responsiveLayout="scroll"
              emptyMessage="Nenhum registro encontrado"
            >
              <Column field="descCronograma" header="Descrição"></Column>
              <Column field="dataInicial" header="Data Inicial"></Column>
              <Column field="dataFinal" header="Data Final"></Column>
              <Column className="p-text-right" body={actionPrrogacoes} field="action" header="Prorrogações"></Column>
              <Column
                className="p-text-right"
                body={actionTemplate}
                field="action"
                header="Ação"
                style={{ width: "12em" }}
              ></Column>
            </DataTable>
            {visibleModal && (
              <ModalRagCronograma
                exercicio={exercicio}
                edit={edit}
                disabled={disabled}
                cronograma={cronograma}
                visible={visibleModal}
                setVisible={setVisibleModal}
                setEdit={setEdit}
                setDisabled={setDisabled}
                setAtualizaList={setAtualizaList}
              />
            )}
          </div>
        </div>
      )}
      {prorrogacao && <Prorrogacao setProrrogacao={setProrrogacao} cronograma={cronograma} exercicio={exercicio} />}
    </>
  );
};
export default Cronograma;
